<template>
    <div class="body">
        <p  class="font1" style="padding-top: 8vh;">自学自练志坚定</p>
        <p  class="font1" style="padding-top: 1vh;">勤勉学习谱华章</p>


        <div style="width: 87%;margin: 0 auto;margin-top: 3vh;">
            <p style="margin: 0 auto; font-size: 20px;color: #000;">EHS+ESG 第三季度主题课程推荐：</p>
            <!-- <a href="https://iedu.foxconn.com/public/play/playCourse?courseId=34060">{{ themeLink[0].Name }}</a> -->
            <ul>
                <a href="https://iedu.foxconn.com/public/play/playCourse?courseId=36893" style="text-decoration: none;color: #000;"><li style="padding: 0;margin-top: 0;">数位转型之路</li></a>
                <a href="https://iedu.foxconn.com/public/play/playCourse?courseId=33600" style="text-decoration: none;color: #000;"><li style="padding: 0;margin-top: 0;">机 智：从数字化车间走向智能制造</li></a>
                <a href="https://iedu.foxconn.com/public/play/play?courseId=42973&companyId=1" style="text-decoration: none;color: #000;"><li style="padding: 0;margin-top: 0;">前沿技术深度探索系列培训之专利管理专场</li></a>
                <a href="https://iedu.foxconn.com/public/play/play?courseId=32397&companyId=1" style="text-decoration: none;color: #000;"><li style="padding: 0;margin-top: 0;">元宇宙与产业应用：新世代数字化世界与工业元宇宙</li></a>
                <a href="https://iedu.foxconn.com/public/play/playCourse?courseId=41589" style="text-decoration: none;color: #000;"><li style="padding: 0;margin-top: 0;">虚实混搭，人工智能贯穿的数字化高韧性企业</li></a>
            </ul>
        </div>
        <div style="width: 87%;margin: 0 auto;margin-top: 3vh;" v-if="coc">
            <p style="margin: 0 auto; font-size: 20px;color: #000;">必修课程完成情况：</p>
            <ul v-for="(item,index) in coc" :key="index" ref="">
                <a :href="item.link" style="text-decoration: none;color: #000;">
                    <li style="padding: 0;margin-top: 0;">{{ item.Name }}&nbsp;
                        <span v-if="item.iscompleted" style="color: green;font-weight: 800;">已完成</span>
                        <span v-else style="color: red;font-weight: 800;">未完成</span>
                    </li>
                </a>
            </ul>
        </div>
        <p style="padding-top: 4vh;text-align: center;">现在的努力铸就了未来的自己</p>
    </div>
</template>
  
<script>
export default {
    props: ["ReportData"],
    components: {},
    data() {
        return {
            themeLink:'',
            coc:'',
            // commentRecommendLink:''
        }
    }, 
    created(){
        // const coc=JSON.parse(this.ReportData.coc)
        // this.themeLink=JSON.parse(this.ReportData.themeLink)
        this.coc=JSON.parse(this.ReportData.coc)
        // console.log(this.themeLink,'主题课程')
    },
    computed:{},
    mounted(){
        
    }
}
</script>

<style scoped>
.body {
    background: url("../../assets/logo.jpg") 15px calc(100% - 20px) no-repeat,
                url("../../assets/24June/logo.png") right  top  no-repeat,
                /* url("../../assets//24February/icon.png") 49% calc(100% + 30px) no-repeat, */
                url("../../assets/24September/bg.jpg")  no-repeat;
    background-size: 17% 8%,110px 35px,cover;
    width: 100%;
    height: 100vh;
}
ul{
    list-style-type: none;
    padding: 0;
    color: #000;
    margin: 0;
    /* text-align: center; */
}
li {
    align-items: center;
    /* margin-bottom: 1px;  */
}

li::before {
    content: '\2022'; /* 使用小圆点作为列表标记 */
    color: #000; /* 可根据需要调整小圆点的颜色 */
    font-size: 1.5em; /* 可调整小圆点的大小 */
    margin-right: 3px; /* 可调整小圆点与文字之间的间距 */
    margin: 0 auto;
}
.font1 {
    width: 92%;
    margin: 0 auto;
    padding-left: 8%;
    /* text-align: center; */
    font-size: 18px;
    color: #e06c24;
    font-weight: bold;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.font2 { 
    width: 90%;
    margin: 0 auto;
    text-align: center;
    padding: 0;
    color: #000;
    font-size: 17px;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
.font3 {
    font-size: 20px;
    font-weight: bold;
    color: #e06c24;
    text-shadow:  -1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff;
    font-family: Helvetica, ‘Hiragino Sans GB’, ‘Microsoft Yahei’, ‘微软雅黑’, Arial, sans-serif;
}
</style>